import { StoreResponseInterface } from '@nts/std/interfaces';
import { GenericServiceResponse } from './generic-service-response';
import { IdentityInterface, ModelInterface } from '@nts/std/interfaces';

export class StoreResponse<
    TModel extends ModelInterface<TIdentity>, 
    TIdentity extends IdentityInterface
> extends GenericServiceResponse<TModel> 
implements StoreResponseInterface<TModel, TIdentity> {

}
